/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-04-07 15:43:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2022-07-04 18:52:14
 * @FilePath: \baishu_react_ui\src\Login\BsyButton\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, {Component} from 'react';
import './index.css'

class BsyBtn extends Component {
    render() {
        const {text,onClick,style} = this.props
        return (
            <button style={style} onClick={onClick} className="BsyButton">
                {text}
            </button>
        );
    }
}

export default BsyBtn;